import { EyeIcon, LockIcon } from "melco-ui";
import { useState } from "react";
import styled from "styled-components";

type PasswordFieldType = {
  password: string;
};

const PasswordWrapper = styled.span`
  margin: 5px 0px;

  border-radius: 3px;
  padding-top: 5px 0px;
`;

const IconWrapper = styled.span`
  margin: 5px;
  padding: 05px 0px;
  font-size: 16px;
`;

export const PasswordField: React.FC<PasswordFieldType> = ({ password }) => {
  const [type, setType] = useState("password");
  return (
    <>
      <PasswordWrapper>
        {type === "password" ? "******************" : password}
        {type === "password" && (
          <IconWrapper>
            <EyeIcon
              onClick={(e) => {
                type === "password" ? setType("text") : setType("password");
              }}
            />
          </IconWrapper>
        )}

        {type !== "password" && (
          <IconWrapper>
            <LockIcon
              onClick={(e) => {
                type === "password" ? setType("text") : setType("password");
              }}
            />
          </IconWrapper>
        )}
      </PasswordWrapper>
    </>
  );
};
